import React, { useMemo } from 'react';
import style from './Services.module.css';
import ServicesItem from './ServicesItem/ServicesItem';

import { useParams } from 'react-router-dom';
import { getTranslation, normalizeLang } from '../../../helpers/translation';

const Services = () => {
  const { lang: rawLang } = useParams();
  const lang = normalizeLang(rawLang);
  const t = useMemo(() => getTranslation(lang), [lang]);

  const items = t.services?.items || [];

  return (
    <div className={style.serviceContainer} id="services">
      <h1>{t.services?.ourServices || 'Our Services'}</h1>

      {t.services?.servicesDescription && (
        <p>{t.services.servicesDescription}</p>
      )}

      <div className={style.pages}>
        {items.map((item, i) => (
          <ServicesItem
            key={item.key || i}
            data={item}
            contactLabel={t.services?.contactUs || 'Contact Us'}
          />
        ))}
      </div>
    </div>
  );
};

export default Services;
